<template>
    <div>
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <div class="container py-2" style="height: calc(100vh - 129px);">
            <div class="d-flex justify-content-between my-3">
                <h1 class="fs-24 text-center">修改{{this.type}}联赛</h1>
                <div>
                    <el-radio v-model="radio" label="fb" @input="changeType">足球</el-radio>
                    <el-radio v-model="radio" label="bb" @input="changeType">篮球</el-radio>
                </div>
            </div>
            <div>
                <!-- <el-input placeholder="搜索国家名..." v-model="input" class="input-with-select mb-3" clearable>
                    <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                </el-input> -->
                <!-- <el-form class="d-flex justify-content-center demo-ruleForm my-3" ref="form" :rules="rules" :model="form" label-width="80px">
                    <el-form-item label="id" prop="id">
                        <el-input v-model="form.id"></el-input>
                    </el-form-item>
                    <el-form-item label="联赛名" prop="name">
                        <el-input v-model="form.c_name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit('form')">添加联赛</el-button>
                    </el-form-item>
                </el-form> -->
                <!--足球-->
                <ux-grid  v-show="radio === 'fb'"
                ref="plxTable"
                stripe
                show-overflow
                use-virtual
                :data = leagueList
                :highlightCurrentRow="true"
                :checkboxConfig="{highlight: true}"
                :edit-config="{trigger: 'click', mode: 'cell'}">
                <ux-table-column field="id" title="联赛id" edit-render :width="isMobile ? 80 : ''">
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.id"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="name" title="联赛名" edit-render :width="isMobile ? '' : ''">
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.name"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="iscup" :title="isMobile ? '杯赛' : '是否杯赛'" :width="isMobile ? 50 : ''">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.iscup">{{isMobile ? '' : '杯赛'}}</el-checkbox>
                    </template>
                </ux-table-column>
                <ux-table-column field="isMerge" :title="isMobile ? '混合' : '是否混合'" :width="isMobile ? 50 : ''">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.isMerge">{{isMobile ? '' : '是'}}</el-checkbox>
                    </template>
                </ux-table-column>
                <ux-table-column field="isHide" :title="isMobile ? '隐藏' : '是否隐藏'" :width="isMobile ? 50 : ''">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.isHide">{{isMobile ? '' : '是'}}</el-checkbox>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" field="detail" :width="60" fixed="right">
                    <template v-slot="scope">
                        <a class="text-primary pointer" @click="removeSelected(scope.row)">删除</a>
                    </template>
                </ux-table-column>
                </ux-grid>
                <!--篮球-->
                <ux-grid  v-show="radio === 'bb'"
                ref="bbTable"
                stripe
                show-overflow
                use-virtual
                :data = leagueList
                :highlightCurrentRow="true"
                :checkboxConfig="{highlight: true}"
                :edit-config="{trigger: 'click', mode: 'cell'}">
                <ux-table-column field="id" title="联赛id" edit-render :width="isMobile ? 80 : ''">
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.id"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="name" title="联赛名" edit-render>
                    <template v-slot:edit="scope">
                        <el-input v-model="scope.row.name"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="iscup" :title="isMobile ? '杯赛' : '是否杯赛'" :width="isMobile ? 50 : ''">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.iscup">{{isMobile ? '' : '杯赛'}}</el-checkbox>
                    </template>
                </ux-table-column>
                <ux-table-column field="isMerge" :title="isMobile ? '混合' : '是否混合'" :width="isMobile ? 50 : ''">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.isMerge">{{isMobile ? '' : '是'}}</el-checkbox>
                    </template>
                </ux-table-column>
                <ux-table-column field="isAfterSn" :title="isMobile ? '季后赛' : '是否季后赛'" :width="isMobile ? 50 : ''">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.isAfterSn">{{isMobile ? '' : '是'}}</el-checkbox>
                    </template>
                </ux-table-column>
                <!-- <ux-table-column field="isShow" title="是否显示">
                    <template v-slot="scope">
                        <el-checkbox v-model="scope.row.isShow">是</el-checkbox>
                    </template>
                </ux-table-column> -->
                <ux-table-column title="操作" field="detail" :width="60" fixed="right">
                    <template v-slot="scope">
                        <a class="text-primary pointer" @click="removeSelected(scope.row)">删除</a>
                    </template>
                </ux-table-column>
                </ux-grid>
            </div>
            <div class="w-100 text-end py-2">
            <el-button @click="insertEvent(-1)">新增联赛</el-button>
            <el-button @click="saveChg">保存修改</el-button>
            </div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
import Nav from '../comment/nav.vue'
import Footer from '../comment/footer.vue'
import { searchLgByCnameUrl, createLeagueUrl, updateLeagueUrl } from '../../constants/http.config'
import { checkDevice, isMobile } from '../../utils/utils'
export default {
    components: { Nav,Footer },
    data(){
        return {
            isDark: false,
            input: '',
            leagueList: [],
            filters: [],
            idList: [],
            loading: false,
            type: '足球',
            radio: 'fb',
            isMobile: false
        }
    },
    mounted() {
        this.getFbLeagueList();
        this.isMobile = checkDevice();
    },
    methods: {
        checkDevice,
        getLeagueList(){
            const url = '/basketball/league/list';
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log(data.data);
                this.leagueList = data.data;
            }).catch(err=>{
                console.log(err);
            })
        },
        getFbLeagueList(){
            const url = '/football/league/list';
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log(data.data);
                this.leagueList = data.data;
            }).catch(err=>{
                console.log(err);
            })
        },
        //删除
        removeSelected(row){
            console.log(row.id);
            if (this.radio === 'fb') {
                this.idList = [];
                this.$refs.plxTable.remove(row)
                this.idList.push(row.id);
            }
            if (this.radio === 'bb') {
                this.idList = [];
                this.$refs.bbTable.remove(row)
                this.idList.push(row.id);
            }
        },
        //新增
        async insertEvent (row) {
            // console.log(row);
            let record
            if (this.radio === 'fb') {
                record = {
                    name: '联赛名',
                    id: 'id',
                    iscup: false,
                    isMerge: false,
                    isHide:false
                } 
                // 加入行, 表示加入行的row对象，row为空则插入第一行，为-1插入最后一行
                let { row: newRow } = await this.$refs.plxTable.insertRow(record, row)
                // 激活单元格编辑
                await this.$refs.plxTable.setActiveRow(newRow)
            }
            if (this.radio === 'bb') {
                record = {
                    name: '联赛名',
                    id: 'id',
                    iscup: false,
                    isAfterSn: false,
                    isMerge: false
                }
                // 加入行, 表示加入行的row对象，row为空则插入第一行，为-1插入最后一行
                let { row: newRow } = await this.$refs.bbTable.insertRow(record, row)
                // 激活单元格编辑
                await this.$refs.bbTable.setActiveRow(newRow)
            }
        },
        async updateLeague(url,chgData){
            fetch(url,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(chgData)
                    })
                    .then(response => response.json());
        },
        async saveChg(){
            let chgData = [];
            if (this.radio === 'fb') {
                chgData = this.$refs.plxTable.getTableData().tableData;
            }
            if (this.radio === 'bb') {
                chgData = this.$refs.bbTable.getTableData().tableData;
            }
            
            console.log(chgData);
            
            chgData.map(obj => {
                delete obj._XID;
                delete obj.detail;
                // 将 id 的值转换为数字
                if (obj.id) {
                    obj.id = Number(obj.id);
                }
                return obj;
            });
            const postData = {
                idList: this.idList,
                chgData,
            }
            console.log(postData);
            let url = ''
            if (this.radio == 'fb') {
                url = '/football/league/change-list';
            }else{
                url = '/basketball/league/change-list';
            }
            
            fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.msg === 'success') {
                    //弹出成功提示
                    this.$alert('更新数据成功！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }else{
                    //弹出失败提示
                    this.$alert('更新数据出错！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }
            })
            .catch(error => {
                console.error('Error:', error);
                //弹出失败提示
                this.$alert('未知错误！更新数据失败！', '', {
                        confirmButtonText: '确定',
                });
            });
        },
        async saveChange(){
            const res = this.$refs.plxTable.getCheckboxRecords();
            console.log(res);
            
            // if (res.length === 0) {
            //     console.log(0);
            //     this.$message({
            //         showClose: true,
            //         type: 'warning',
            //         message: '请选中至少一条数据!'
            //     });
            // }else{
            //     // console.log(res);
            //     let countSuccess = 0;
            //     let countFail = 0;
            //     const requests = [];
            //     for (let index = 0; index < res.length; index++) {
            //         const chgData = res[index];
            //         // const url = '/league/update';
            //         const request = fetch(updateLeagueUrl,{
            //             method: 'POST',
            //             headers: {
            //                 'Content-Type': 'application/json'
            //             },
            //             body: JSON.stringify(chgData)
            //         })
            //         .then(response => response.json())
            //         .then(data => {
            //             console.log(data);
            //             if (data.msg == 'success') {
            //                 countSuccess++;
            //             }else{
            //                 countFail++;
            //             }
            //         }).catch(error => {
            //             console.error('Error:', error);
            //         });
            //         requests.push(request);        
            //     }
            //     Promise.all(requests).then(() => {
            //         this.$notify.info({
            //             title: '消息',
            //             message: `更新${countSuccess}条成功，${countFail}条失败`
            //         });
            //     }).catch(error => {
            //         console.error('Error:', error);
            //     });
            // }
        },
        onSubmit(formName){
            // console.log(this.form);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$message.error('添加的id、国家、态况名、捷报名不能为空!');
                    // const url = '/league/create';
                    fetch(createLeagueUrl,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(this.form)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if (data.msg == 'success') {
                            this.$notify({
                                title: '成功',
                                message: '添加联赛成功，' + data.data,
                                type: 'success'
                            });
                        }else{
                            this.$notify.error({
                                title: '失败',
                                message: data.data
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.$notify.error({
                            title: '错误',
                            message: '添加联赛出错'
                        });
                    });
                } else {
                    this.$message.error('添加的id、联赛名不能为空!');
                }
            })
        },
        changeType(){
            if (this.radio === 'fb') {
                this.type = '足球';
                this.leagueList = [];
                this.getFbLeagueList();
                this.$refs.plxTable.reloadData(this.leagueList);
            }else{
                this.type = '篮球';
                this.idList = [];
                this.leagueList = [];
                this.getLeagueList();
                this.$refs.plxTable.reloadData(this.leagueList);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../assets/sass/global.scss';
</style>